/* eslint-disable no-alert */
import React from 'react'
import moment from 'moment'
import styled from 'styled-components'
import _ from 'lodash'
import { Table, Button, Label } from 'semantic-ui-react'

const StartDate = styled.div`
  color: rgb(208, 62, 62);
  font-weight: bold;
`

const EndDate = styled.div`
  color: rgb(33,186,69);
  font-weight: bold;
`

export default class RequestRow extends React.Component {
  state = {
    loading: false,
  }

  renderPendingActions = () => {
    const { loading } = this.state
    const { onConfirm, onCancel } = this.props

    return (
      <div style={{ width: 156 }}>
        <Button disabled={loading} size="mini" onClick={onConfirm} style={{ width: 75 }}>
          Confirm
        </Button>
        <Button
          disabled={loading}
          size="mini"
          color="red"
          onClick={onCancel}
          style={{ width: 75 }}
        >
          Cancel
        </Button>
      </div>
    )
  }

  renderStatus = status => (
    <Label color={status === 'completed' ? 'green' : 'red'} style={{ width: 75 }}>
      {_.capitalize(status)}
    </Label>
  )

  render() {
    const { request } = this.props

    const requestedDate = moment(request.created_at).format('DD/MM/YYYY')
    const startedAt = moment(request.started_at).format('DD/MM/YYYY')
    const endedAt = moment(request.ended_at).format('DD/MM/YYYY')

    return (
      <Table.Row>
        <Table.Cell>{requestedDate}</Table.Cell>
        <Table.Cell textAlign="center">{request.merchant_name}</Table.Cell>
        <Table.Cell textAlign="center">{request.branch_name}</Table.Cell>
        <Table.Cell textAlign="center">{request.requested_by}</Table.Cell>

        <Table.Cell textAlign="center">
          <StartDate>{startedAt}</StartDate>
        </Table.Cell>
        <Table.Cell textAlign="center">
          <EndDate>{endedAt}</EndDate>
        </Table.Cell>
        <Table.Cell>
          {this.renderPendingActions(request.doc_id)}
        </Table.Cell>
      </Table.Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/merchantCloseRequests/components/RequestRow.js